import React from 'react';

export const EllipsisDots = () => (
  <div className="flex items-center justify-center gap-1">
    <div className="h-1 w-1 bg-gray-300 rounded-full" />
    <div className="h-1 w-1 bg-gray-300 rounded-full" />
    <div className="h-1 w-1 bg-gray-300 rounded-full" />
  </div>
);
